import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 px-4">
      <div className="text-center max-w-md">
        <div className="font-heading text-8xl font-bold tabular-nums tracking-tighter text-slate-900" data-testid="not-found-title">404</div>
        <p className="mt-4 text-lg text-slate-700">This page isn't in the workspace.</p>
        <p className="mt-2 text-sm text-slate-500">Maybe the link is stale, or a transaction was archived. Head back to your dashboard and continue from there.</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-md px-4 py-2.5 text-sm font-semibold text-white" style={{ background: "var(--primary-hex, #1F6FEB)" }} data-testid="not-found-home-link">
          <Home className="h-4 w-4" /> Back to today
        </Link>
      </div>
    </div>
  );
}
